import t from '../../../react-translate';
import submitQuiz from '../../services/component-submit-quiz.ts';

export default {
  bindings: {
    lectureComponent: '<',
    editMode: '<',
    restrictedEditMode: '<',
    reorderMode: '<',
    index: '<',
    context: '<',
  },
  controller: function ctrl(
    $controller,
    _,
    AlertMessages,
    RailsRoutes,
    nvUtil,

    CurrentCourseManager,
    CurrentUserManager,
    TimelinesManager,
    config,
  ) {
'ngInject';
    angular.extend(this, $controller('LectureComponentBaseCtrl'));
    const vm = this;

    vm.config = config;

    vm.remainUnansweredRequiredQuestions = () => vm.lectureComponent.quiz.questions.some(
      (question) => {
        if (question.isRequired && question.type === 'MultipleChoiceMultipleAnswerQuestion') {
          return !question.hasSelectedOneAtLeast();
        }

        return false;
      },
    );

    vm.submit = (lectureComponent) => {
      submitQuiz(lectureComponent)
        .then((response) => {
          const { quiz } = lectureComponent;
          lectureComponent.shouldShowFeedback = true;
          quiz.pointsReceived = quiz.submission.pointsReceived;

          if (CurrentCourseManager.course.gamificationEnabled) {
            // TODO: Thse timelines manager updates are likely broken
            TimelinesManager.updateComponentPointsAndProgress(lectureComponent.lecturePage.id, lectureComponent.type, lectureComponent.id,
              quiz.submission.pointsReceived);

            if (quiz.submission.pointsReceived) {
              vm.showPointsModal(quiz.submission, null);
            }
          } else {
            TimelinesManager.updateComponentProgress(lectureComponent.lecturePage.id, lectureComponent.type, lectureComponent.id, lectureComponent.quiz.progress);
            AlertMessages.success('', 'SURVEYS.RESPONSES_SUBMITTED_SUCCESSFULLY');
          }

          if (!CurrentUserManager.isAdmin()) {
            nvUtil.addUserToHeads(CurrentUserManager.user, lectureComponent.quiz.usersRecentlyCompleted);
          }
        }).catch(
          (error) => {
            AlertMessages.error('', 'FORM.ERROR');
          },
        );
    };

    vm.setEditMenu = () => {
      const { sharedProps } = this.context;
      const extraOptions = [];

      extraOptions.push({
        type: 'link',
        link: RailsRoutes.editQuestionSetPath(vm.$stateParams.catalogId, vm.lectureComponent.quiz.id),
        text: t.LECTURE_PAGES.COMPONENTS.QUIZ.DROPDOWN.EDIT_QUESTIONS(),
      });

      if (!vm.CurrentCourseManager.course.isSelfPaced) {
        extraOptions.push({
          type: 'text',
          text: vm.lectureComponent.hasDeadline() ? t.LECTURE_PAGES.COMPONENTS.QUIZ.DROPDOWN.REMOVE_DEADLINE() : t.LECTURE_PAGES.COMPONENTS.QUIZ.DROPDOWN.ADD_DEADLINE(),
          callback: () => {
            vm.toggleDeadline();
            vm.setEditMenu();
          },
        });
      }

      sharedProps.extraOptions = {
        ...sharedProps.extraOptions,
        ...{
          options: extraOptions,
        },
      };
    };

    vm.setEditMenu();

    /* Admin Actions */
  },
  controllerAs: 'vm',
  templateUrl: 'lecture_pages/templates/components/nv-survey-lecture-component.html',
};
